import { useEffect } from "react";
import { CircularProgress, Box } from "@mui/material";
import { secureStorage } from "../utils/security";

const LogoutCallback = () => {
  useEffect(() => {
    console.log("Processing logout callback");
    // Clear all tokens and session storage
    secureStorage.clearAllTokens();
    sessionStorage.clear();

    // Start with a fresh Keycloak adapter on the login page. A client-side
    // navigation would reuse the callback page's intentionally skipped init.
    window.location.replace("/login");
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default LogoutCallback;
